export default __webpack_public_path__ + "static/media/04.c8de4e96.jpeg";